



































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class DirectSubscription extends Vue {
    loading = false
    formValid = false
    chip = false;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: {[key: string]: any} = {
        typeId: {
            id: null
        }
    }

    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ]
    }

    uploadFile () {
        this.loading = true
        this.$store
            .dispatch('createDirectSubscription', {
                uploadfile: this.formData.uploadfile
            })
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.formData.uploadfile = null
                } else {
                    this.$store.commit('reportError', { message: resp?.data?.message || 'File NOT save.' })
                }
                this.loading = false
            })
    }
}
